import { createStart } from '@tanstack/react-start'
import { httpErrorMiddleware } from './server/middleware'

export const startInstance = createStart(() => ({
  functionMiddleware: [httpErrorMiddleware],
}))

// Server-only initialization. `import.meta.env.SSR` is Vite-substituted at
// build time, so the import below is dead-code-eliminated from the client
// bundle entirely — without it, the `@rapid-response/db` transitive import
// would pull `postgres` into the browser (see the server/client boundary
// rule in CLAUDE.md).
if (import.meta.env.SSR) {
  await import('./server/boot-reconcile')
}
